<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						template(v-if='settings.selectedLetters.length')
								span
										| {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}:
										| {{ settings.selectedLetters.join(', ') }}
								br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}:
								| {{ settings.amountOfRows }}
						br
						template(v-if='settings.invertedLetters')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_invertedLetters') }}: {{ $i18n.t('common.common_button_yes') }}
								br
				br
				slot

</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
